import { ReactNode } from "react";
import { Link as RouterLink } from "react-router";

export interface ResponsiveDropdownItem {
  label: string;
  testId?: string;
  to?: string;
  onClick?: () => void;
  selected?: boolean;
  icon?: ReactNode;
  startsGroup?: boolean;
  // color for the item's icon + label (e.g. "error.main" for a delete action)
  color?: string;
}

// A titled cluster of items — several of these combine into one grouped menu
// (e.g. the mobile "+" that merges "New Depot" and "New Investment").
export interface ResponsiveDropdownGroup {
  title?: string;
  icon?: ReactNode;
  items: ResponsiveDropdownItem[];
}

export const itemLinkProps = (item: ResponsiveDropdownItem) =>
  item.to ? { component: RouterLink, to: item.to } : {};
